import type { TabId, UserRole } from '../types'
import { FIELD_USER_ROLES, TECHNICAL_USER_ROLES, isFieldUserRole } from './roles'

export type AccessTabDef = {
  id: TabId
  label: string
  icon: string
  roles: UserRole[]
}

export const ACCESS_TABS: AccessTabDef[] = [
  { id: 'dashboard', label: 'Dashboard', icon: '📊', roles: ['admin', 'responsavel_tecnico'] },
  { id: 'operadora', label: 'Operadora', icon: '🏢', roles: ['admin'] },
  { id: 'documentos', label: 'Documentos', icon: '📁', roles: ['admin', 'responsavel_tecnico', 'caar', 'piloto', 'aplicador', 'tecnico_agricola'] },
  { id: 'frota_equipamentos', label: 'Frota e Equipamentos', icon: '🚁', roles: ['admin', 'piloto', 'caar'] },
  { id: 'equipe', label: 'Equipe', icon: '👥', roles: ['admin'] },
  { id: 'operacoes', label: 'Operações', icon: '📋', roles: ['admin', 'responsavel_tecnico', ...FIELD_USER_ROLES] },
  { id: 'checklists', label: 'Checklists', icon: '✅', roles: ['admin', 'responsavel_tecnico', ...FIELD_USER_ROLES] },
  { id: 'relatorios', label: 'Relatórios', icon: '📊', roles: ['admin', 'responsavel_tecnico', 'caar', 'piloto'] },
  { id: 'consulta', label: 'Consulta', icon: '🔎', roles: ['admin', ...TECHNICAL_USER_ROLES, 'caar', 'piloto'] },
  { id: 'auditoria', label: 'Auditoria', icon: '🔍', roles: ['admin', 'responsavel_tecnico'] },
]

export function roleCanAccessTab(role: string | null | undefined, tabId: TabId) {
  if (!role) return false
  const tab = ACCESS_TABS.find(item => item.id === tabId)
  return !!tab?.roles.includes(role as UserRole)
}

export function getTabsForRole(role: string | null | undefined) {
  if (!role) return []
  return ACCESS_TABS.filter(tab => tab.roles.includes(role as UserRole))
}

export function getDefaultRouteForRole(role: string | null | undefined) {
  if (!role) return '/painel'

  if (role === 'admin') {
    return '/painel'
  }

  if (role === 'responsavel_tecnico' || role === 'consultor') {
    return '/painel'
  }

  if (role === 'caar') {
    return '/campo'
  }

  if (isFieldUserRole(role)) {
    return '/campo'
  }

  return '/painel'
}
